<template>
  <div class="bg_linear_to_t">
    <CommonBreadcrumb />
    <div
      :class="['page_view h-200 text-white', 'flex flex-col gap-y-10 justify-center items-center']"
    >
      <UIcon name="mdi:shield-warning-outline" :class="['lg:size-32 size-24', 'text-app-white']" />
      <h1 class="min-h-lh lg:text-3xl text-2xl font-semibold text-center">
        {{ t('tip.maintenance') }}
      </h1>

      <!-- 返回按钮 -->
      <CommonBtnPress
        :label="t(`action.goBack`)"
        :type="2"
        leading-icon="fe:arrow-left"
        @click="useGoBack()"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
</script>
